var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('p',[_c('input',{attrs:{"type":"file","id":"my_file_input"},on:{"change":_vm.inputFile}})]),_c('p',[_c('pre',[_vm._v(_vm._s(_vm._f("pretty")(_vm.test)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }